import ReactGA from "react-ga4";

const ENVIRONMENT = process.env.REACT_APP_ENV || "development";

export const TRACKING_ID = ENVIRONMENT === "prod" ? "G-JCM7Z4RL5L" : null;

export const logPageView = (page, title) => {
  try {
    if (ENVIRONMENT === "prod") {
      ReactGA.send({ hitType: "pageview", page, title });
    }
  }
  catch (error) {
    console.error("Error logging page view:", error);
  }
};
